export default [
  {
    path: "home",
    name: "DashboardHome",
    meta: {
      title: "首页"
    },
    component: resolve => require(["@/views/home/Index.vue"], resolve)
  },
  {
    path: "org_base_info",
    name: "OrgBaseInfo",
    meta: {
      title: "基本信息"
    },
    component: resolve => require(["@/views/baseInfo/Base.vue"], resolve)
  }
];
